import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';
import { Button, Col, Image, Row, Typography } from 'antd';

import classes from './index.module.less';

const ArticleDownloadBanner = () => {
	const OS = isAndroid
		? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
		: isWindows
			? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
			: isMacOs
				? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
				: isIOS
					? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
					: 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID';

	return (
		<div className={classes.pagehero}>
			<Row>
				<Col md={1} sm={1} xs={1} lg={1} xl={1}></Col>
				<Col md={10} sm={10} xs={22} lg={13} xl={13}>
					<div className={classes.section}>
						<Typography className={classes.title}>
							<span className={classes.textPink}>Jadilah orang tua super!</span> Panduan 1000 Hari Pertama Kehidupan si kecil ada di sini. <span className={classes.textPink}>GRATIS.</span>
						</Typography>
					</div>
				</Col>
				<Col md={2} sm={2} xs={1} lg={2} xl={2}></Col>
			</Row>
			<Row>
				<Col md={2} sm={2} xs={1} lg={2} xl={2}></Col>
				<Col md={0} sm={0} xs={23} lg={0} xl={0}>
					<div className={classes.store}>
						<Image
							src="/images/branda/hero/logoAppStore.webp"
							alt="image"
							style={{
								width: 107,
								height: 31,
								cursor: 'pointer',
							}}
							preview={false}
							onClick={() => window.open(OS)}
							id="home-app-store"
						/>
						<span style={{ margin: '5px' }}></span>
						<Image
							src="/images/branda/hero/logoPlayStore.webp"
							alt="image"
							style={{
								width: 107,
								height: 31,
								cursor: 'pointer',
							}}
							preview={false}
							onClick={() => window.open(OS)}
							id="home-play-store"
						/>
					</div>
				</Col>
				<Col md={20} sm={20} xs={24} lg={20} xl={20}>
					<Row>
						<Col md={6} sm={6} xs={24} lg={6} xl={6}>
							<div className={classes.btnFooter} style={{ marginTop: '5px' }}>
								<Button
									className={classes.btn}
									onClick={() => window.open(OS)}
									size="large"
									id="download-sekarang"
								>
									<Typography className={classes.btnText}>Download Sekarang</Typography>
								</Button>
							</div>
						</Col>
						<Col md={10} sm={10} xs={0} lg={10} xl={10}>
							<div className={classes.store}>
								<Image
									src="/images/branda/hero/logoAppStore.webp"
									alt="image"
									style={{
										width: 107,
										height: 31,
										cursor: 'pointer',
									}}
									preview={false}
									onClick={() => window.open(OS)}
									id="home-app-store"
								/>
								<span style={{ margin: '5px' }}></span>
								<Image
									src="/images/branda/hero/logoPlayStore.webp"
									alt="image"
									style={{
										width: 107,
										height: 31,
										cursor: 'pointer',
									}}
									preview={false}
									onClick={() => window.open(OS)}
									id="home-play-store"
								/>
							</div>
						</Col>
					</Row>
				</Col>
				<Col md={2} sm={2} xs={0} lg={2} xl={2}></Col>
			</Row>
		</div>
	);
};

export default ArticleDownloadBanner;
